module.exports = __webpack_public_path__ + "img/sponsor_bg.5d8b8bff.png";